






	// @ts-ignore
    import _ from './CHeaderImg.ts'; export default _;
